export const faqData = {
  general: [
    {
      question: "Can I pay with crypto?",
      answer:
        "Absolutely! At checkout, you can pay your way, with a credit card or crypto for maximum convenience.",
    },
    {
      question: "Crypto vs. Credit Card: What’s the difference?",
      answer:
        "Crypto is a one-time payment with no subscription. A credit card is a recurring monthly subscription.",
    },
    {
      question:
        "I’m only interested in using AI Signals. Which plan should I choose?",
      answer:
        "To access AI Signals, including real-time data, you need the Pro Plan.",
    },
    {
      question: "How can I cancel my plan?",
      answer:
        "To cancel your subscription, go to your current plan, click View Details, and then select Cancel.",
    },
    {
      question:
        "What are the available pricing tiers for the trading platform?",
      answer:
        "The trading platform offers four tiers: Free Trial, Lite, Pro, and Enterprise. Each tier provides different levels of access to features and capabilities.",
    },
    {
      question: "Does the platform offer a free trial?",
      answer:
        "Yes, the Free Trial tier is available, providing limited access to features such as Core Trading, Terminal Trading, Paper Trading on a Demo account, one exchange integration, and three daily AI Trading Live Suggestions.",
    },
  ],
  basic: [
    {
      question: "Is Core Trading available across all tiers?",
      answer:
        "Yes, Core Trading is included in all tiers: Free Trial, Lite, Pro, and Enterprise.",
    },
    {
      question: "What is Terminal Trading, and which tiers include it?",
      answer:
        "Terminal Trading is a feature that provides advanced trading capabilities through a dedicated terminal interface. It is available in all tiers: Free Trial, Lite, Pro, and Enterprise.",
    },
    {
      question: "Does the platform support Paper Trading?",
      answer:
        "Yes, Paper Trading on a Demo account is supported across all tiers, allowing users to practice trading without risking real funds.",
    },
    {
      question: "How many exchange integrations are available in each tier?",
      answer:
        "The number of exchange integrations varies by tier:\n" +
        "-Free Trial: 1 integration\n" +
        "-Lite: 2 integrations\n" +
        "-Pro: 10 integrations\n" +
        "-Enterprise: 25 integrations\n",
    },
    {
      question:
        "What is Sentiment Analysis, and how is it provided across tiers?",
      answer:
        " Sentiment Analysis delivers AI-driven insights into market sentiment. Availability:\n" +
        "-Free Trial: Delayed (Preview)\n" +
        "-Lite: 5 daily analyses\n" +
        "-Pro: 10 daily analyses\n" +
        "-Enterprise: Unlimited analyses\n" +
        "(Dashboard - Market Overview).\n",
    },
    {
      question: "Are Real-time AI Signals available, or is there a delay?",
      answer:
        "AI Signals are available in all tiers with a 5-minute delay (Dashboard - Signal section). Real-time AI Signals (no delay) are exclusive to Pro and Enterprise tiers.",
    },
  ],
  bot: [
    {
      question: "Are Trading Bots available in all tiers?",
      answer:
        "Trading Bots are not available in the Free Trial tier. The other tiers include:\n" +
        "-Lite: 1 bot\n" +
        "-Pro: 5 bots\n" +
        "-Enterprise: 20 bots\n",
    },
    {
      question: "What are Bot Backtests, and how many are allowed per month?",
      answer:
        "Bot Backtests allow users to test trading bot strategies against historical data. The limits are:\n" +
        "-Free Trial: Not available\n" +
        "-Lite: 5 backtests per month\n" +
        "-Pro: 20 backtests per month\n" +
        "-Enterprise: 50 backtests per month\n",
    },
    {
      question: "Are Copy Trading Bots supported, and in which tiers?",
      answer:
        "Copy Trading Bots, which allow users to replicate the strategies of other traders, are available in the Lite, Pro, and Enterprise tiers but not in the Free Trial.",
    },
  ],
  signals: [
    {
      question:
        "What markets can I analyze with AI Assistant Suggestions in Australia or Iran, and which tiers support this feature?",
      answer:
        "AI Assistant Suggestions different analyses based on various risk appetites and data categories for crypto (all coins), forex, and stock trading in Australia. (AI Assistant) ",
    },
    {
      question:
        "What are Pivot checks, and how many are provided in each tier?",
      answer:
        "A Pivot check looks for a turn on the timeframe you pick. It is not the category call on the AI Assistant. The availability is as follows:\n" +
        "-Free Trial: 3 daily suggestions\n" +
        "-Lite: 30 daily suggestions\n" +
        "-Pro: 300 daily suggestions\n" +
        "-Enterprise: Unlimited suggestions\n" +
        "(Buy/Sell forms in different locations like AI Assistant, Insights,...)\n",
    },
    {
      question: "How many guide questions are included in each tier?",
      answer:
        "Guide questions are answers in the guide chat. Each tier has a daily cap:\n" +
        "-Free Trial: 3 daily questions\n" +
        "-Lite: 10 daily questions\n" +
        "-Pro: 50 daily questions\n" +
        "-Enterprise: 150 daily questions\n" +
        "The count resets the next day.\n",
    },
    {
      question:
        "What is the difference between a Pivot check and the AI Assistant?",
      answer:
        "The AI Assistant is the category call, such as Technical Indicators, On-chain, Social, or AI. Follow that row for a longer hold. A Pivot check only looks for a turn on 15 minutes, 1 hour, 4 hours, 1 day, or 1 week. If they disagree, the pivot is not a coin to add.",
    },
    {
      question:
        " What is AI-assisted Trading, and in which tiers is it offered?",
      answer:
        "AI-assisted Trading provides advanced AI-driven support for executing trades. It is available with unlimited access in the Pro and Enterprise tiers. (Buy/Sell Forms in AI Assistant)",
    },
    {
      question: "Can I backtest AI signals, and in which tiers?",
      answer:
        "Signal Backtests, which test AI-generated signals against historical data, are available only in the Pro and Enterprise tiers, with unlimited backtests in both.",
    },
  ],
  advanced: [
    {
      question: "What is the Alert System, and which tiers include it?",
      answer:
        "The Alert System notifies users of specific market conditions or trading opportunities. It is available only in the Pro and Enterprise tiers.",
    },
    {
      question: "Is the Custom Strategy Builder available in all tiers?",
      answer:
        "The Custom Strategy Builder, which allows users to create personalized trading strategies, is available only in the Pro and Enterprise tiers. You can find this feature in the Insight section.",
    },
    {
      question: "What is the Trade Simulator, and which tiers include it?",
      answer:
        "The Trade Simulator allows users to simulate trades in a virtual environment. It is available only in the Enterprise tier.",
    },
    {
      question: "Is there a Developer API for integrating with the platform?",
      answer:
        "Yes, a Developer API is available for custom integrations, but it is exclusive to the Enterprise tier.",
    },
  ],
};
